import { Button } from "components/DesignSystem/Button/Button";
import HeaderFilter from "components/DesignSystem/HeaderFilter/HeaderFilter";
import Radio from "components/DesignSystem/RadioGroup/RadioGroup";
import { Funnel } from "components/icons/Funnel";
import { AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

export type UpdateFilterType = (name: string, value: string[] | null) => void;

export const ColumnHeaderRadioFilter = ({
  isActive,
  onValueChange,
  selected,
  className = "t-w-64",
  options,
  handleClearFilter,
}: {
  isActive: boolean;
  selected: string;
  onValueChange: (value: string) => void;
  className?: string;
  options: { label: string; value: string }[];
  handleClearFilter: () => void;
}) => {
  const [tempSelected, setTempSelected] = useState(selected);
  const [isOpen, setOpen] = useState(false);

  const updateTempSelected = (value: string) => {
    setTempSelected(value);
  };

  const applyFilter = () => {
    onValueChange(tempSelected);
    setOpen(false);
  };

  useEffect(() => {
    setTempSelected(selected);
  }, [selected]);

  return (
    <HeaderFilter.Root open={isOpen} setOpen={setOpen}>
      <HeaderFilter.Trigger
        icon={<Funnel />}
        isActive={isActive}
        selectedCount={1}
        onClear={handleClearFilter}
        setOpen={setOpen}
      />
      <AnimatePresence>
        <HeaderFilter.Portal {...HeaderFilter.Portal}>
          <HeaderFilter.Content className={className}>
            <HeaderFilter.Body>
              <Radio.Root
                value={tempSelected}
                onValueChange={updateTempSelected}
              >
                <Radio.Content className="t-gap-3 t-flex t-flex-col">
                  {options.map((item) => (
                    <Radio.Item key={item.value} value={item.value}>
                      {item.label}
                    </Radio.Item>
                  ))}
                </Radio.Content>
              </Radio.Root>
            </HeaderFilter.Body>
            <HeaderFilter.Footer>
              <Button size="small" onClick={() => setOpen(false)}>
                Clear
              </Button>
              <Button customType="primary" size="small" onClick={applyFilter}>
                Apply
              </Button>
            </HeaderFilter.Footer>
          </HeaderFilter.Content>
        </HeaderFilter.Portal>
      </AnimatePresence>
    </HeaderFilter.Root>
  );
};
